import React from 'react'
import styled from 'styled-components'
import { MdOutlineArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md'

const Pagination = () => {
  return (
    <Container>

            <div>  
                <div> <MdOutlineArrowBackIosNew /> <span> Previous </span> </div>     
                    <p>
                        <ul>
                            <li> 1 </li>
                            <li> 2 </li>
                            <li> 3 </li>
                            <li> 4 </li>
                            <li> 5 </li>
                        </ul>       
                    </p>
                <div>  <span> Next </span> <MdArrowForwardIos /> </div> 
            </div>
    </Container>
  )
}

const Container = styled.section`
    display: flex;
    width: 80%;
    justify-content: space-between;
    margin: 5rem auto;

    @media screen and (max-width: 600px){    
        width: 100%;
        align-items: center;
        margin-top: 5rem;
        margin-bottom: 5rem;
        /* border: 1px solid red; */
        }
    

    & > div{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        /* background-color: #2A870E; */

       

        &  p{
            color: #101828;
            padding-left: 1.2rem;
            
            & > ul{
            display: flex;
            flex-direction: row;

            &  li{
                margin-right: 20px;
                cursor: pointer;
                border: 1px solid #101828;

                & :hover{
                    /* cursor: progress; */
                    opacity: 0.8;
                    transition: 0.5s ease-out;
                }
        
                
                
                @media screen and (max-width: 600px){    
                /* padding: 12px 20px; */
                font-size: 1.4rem;
        }

                & :hover, :focus {
                    transition: all 0.5s;
                    border-bottom: 1px solid #2A870E;
                }
            }
            }
        
        }

        &  div{

            display: flex;
            align-items: center;
            background-color: #2A870E;
            color: #fff;
            text-align: center;
            padding: 18px 32px;
            cursor: pointer;

            @media screen and (max-width: 600px){    
                padding: 12px 20px;
        }

                &  span{
                font-size: 16px;
                width: fit-content;
                height: fit-content;

                @media screen and (max-width: 600px){
                    display: none;
                }
       
        }

    }
}
    
`

export {Pagination}